import React from 'react';
import { useUIDSeed } from 'react-uid';
/**
 * Select Dropdown Group Item - supposed to be rendered inside the Select Dropdown component
 */
const SelectDropdownGroup = ({ optgroup, children }) => {
    const seed = useUIDSeed();
    const ID = `apricot_select_${seed('dropdown')}`;
    return (React.createElement("li", { role: "none" },
        React.createElement("ul", { role: "group", "aria-labelledby": ID },
            React.createElement("li", { "aria-hidden": "true", role: "presentation", className: "cb-dropdown-header", tabIndex: -1 },
                React.createElement("p", { id: ID }, optgroup)),
            children)));
};
export default SelectDropdownGroup;
//# sourceMappingURL=SelectDropdownGroup.js.map